/* src/app/webhook-creator/webhook-creator/webhook-form-components/webhook-form-input/webhook-form-input.component.scss */
.ant-input-clear-icon {
  margin-right: 6px;
  cursor: pointer;
}
/*# sourceMappingURL=webhook-form-input.component.css.map */
